var _path, _path2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBitcoin = function SvgBitcoin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6797 14.6457C21.2105 20.5386 15.242 24.1249 9.34837 22.6554C3.45717 21.1862 -0.129175 15.2173 1.3407 9.32476C2.8092 3.43117 8.77774 -0.155517 14.6696 1.31367C20.5629 2.78286 24.1489 8.75242 22.6797 14.6457Z",
    fill: "url(#paint0_linear_906_7735)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8471 10.4329C17.0661 8.96917 15.9517 8.18233 14.4278 7.65742L14.9221 5.67467L13.7152 5.37389L13.234 7.30439C12.9167 7.22533 12.5908 7.15073 12.267 7.07683L12.7517 5.13361L11.5455 4.83282L11.0508 6.81489C10.7882 6.75508 10.5304 6.69595 10.2801 6.63373L10.2815 6.62754L8.61708 6.21195L8.29601 7.50101C8.29601 7.50101 9.19148 7.70623 9.17258 7.71895C9.66139 7.84098 9.74973 8.16445 9.73495 8.42089L9.17189 10.6797C9.20558 10.6883 9.24923 10.7006 9.29736 10.7199C9.25714 10.7099 9.21417 10.6989 9.16983 10.6883L8.38058 13.8525C8.32076 14.001 8.16917 14.2237 7.82748 14.1392C7.83951 14.1567 6.95023 13.9202 6.95023 13.9202L6.35107 15.3017L7.92167 15.6933C8.21386 15.7665 8.5002 15.8431 8.78208 15.9153L8.28261 17.9208L9.48814 18.2215L9.9828 16.2374C10.3121 16.3268 10.6318 16.4093 10.9446 16.487L10.4517 18.4618L11.6586 18.7626L12.1581 16.761C14.2161 17.1504 15.7636 16.9933 16.4151 15.1319C16.94 13.6332 16.3889 12.7686 15.3061 12.2049C16.0947 12.023 16.6887 11.5043 16.8471 10.4329ZM14.0896 14.2997C13.7166 15.7985 11.1931 14.9882 10.375 14.7851L11.0378 12.1282C11.8559 12.3324 14.4794 12.7367 14.0896 14.2997ZM14.4629 10.4112C14.1226 11.7745 12.0223 11.0819 11.341 10.912L11.9418 8.50236C12.6231 8.67217 14.8173 8.98911 14.4629 10.4112Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_906_7735",
    x1: 1.01123,
    y1: 0.984497,
    x2: 1.01123,
    y2: 22.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9AA4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931A"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBitcoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bitcoin.df1b2eb3.svg";
export { ForwardRef as ReactComponent };